import React from 'react';
import styles from './stack.module.scss';

type StackProps = {
  children: React.ReactNode;
}

/**
 * Stacks elements in strips across the page, with a gap between them
 * @param {React.ReactNode} props.children
 * @returns {JSX.Element}
 */
export const Stack: React.FC<StackProps> = ({ children }) => (
  <div className={styles.stack}>
    {children}
  </div>
);